module.exports = __webpack_public_path__ + "svg/payouts.90d99790243c88cfab51a8d3035590ac.svg";